import React from "react";
import RoentgenStatistikk from "./RoentgenStatistikk";


const AvkomRoentgenStatistikk = (props) => {
    const statistikk = props.avkomStatistikk;
    const raseStatistikk = props.raseStatistikk;



    return (
        <div>
            <div className="dogweb-card">
                <div className="statistikk-info">
                    <div className="hunden">
                        { statistikk !== null && raseStatistikk !== null &&
                            <>
                                <p><strong>Denne Hund</strong></p>
                                <p><span>Antal hvalpe:</span> {statistikk.antallAvkom}</p>

                                {
                                    statistikk.gjennomsnittligAntAvkomPerAar > 100 &&
                                    <p><span>Matadoravlsgrænse</span> {statistikk.matadorAntall} hvalp</p>
                                }
                                {
                                    statistikk.gjennomsnittligAntAvkomPerAar < 100 &&
                                    <p><span>Matadoravlsgrænse</span> ikke relevant i denne race, da den har under 100 reg./år</p>
                                }
                            </>
                        }
                    </div>
                    <div className="racen">
                        { statistikk !== null && raseStatistikk !== null &&
                            <>
                                <p><strong>Race sidste 10 år</strong></p>
                                <p><span>Antal hvalpe:</span> {raseStatistikk.antallAvkom} </p>
                            </>
                        }
                    </div>
                </div>
            </div>
            { statistikk !== null && raseStatistikk !== null &&
                <>
                    <RoentgenStatistikk statistikk={statistikk}
                                        raseStatistikk={raseStatistikk} />
                </>
            }


        </div>

    );
};
export default AvkomRoentgenStatistikk;